import React from 'react';
import { Avatar, Flex, Text } from '@chakra-ui/react';
import { peso, priceStx } from 'utils/utility';

const TopBidder = ({ topBider, auction, price_usd, finish }) => {
  return (
    <Flex w={{ base: '100%', md: '100%' }} border="solid 1px #eee" py="10px" borderRadius={12}>
      <Flex
        id="current"
        borderRight={1}
        borderColor={{ base: '#F7F7F7', md: '#cecece' }}
        borderStyle="dashed"
        flexDirection="column"
        fontSize="14px"
        flex="1"
        p="15px 10px 15px 25px"
        justifyContent="center"
      >
        <Text>Top Bidder</Text>
        <Flex mt="6px">
          <Avatar name={topBider?.user?.username} size="xs" mr="8px" bg="#BC3153" />
          <Text fontSize="16px" fontWeight="bold">
            {topBider?.user?.username}
          </Text>
        </Flex>
      </Flex>
      <Flex
        id="current"
        borderColor={{ base: '#F7F7F7', md: '#cecece' }}
        borderStyle="dashed"
        flexDirection="column"
        fontSize="14px"
        p="15px"
        flex="1"
        justifyContent="center"
      >
        <Text fontSize={finish ? '20px' : '24px'} fontWeight="bold" py="10px" alignSelf="center">
          {auction?.highest_bid === null ? peso(price_usd) : peso(auction?.highest_bid?.amount / 100)}
        </Text>
        <Text alignSelf="center">{priceStx(topBider?.amount_micro_stx)}</Text>
      </Flex>
    </Flex>
  );
};

export default TopBidder;
